import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from '@boels/helpers';
import {
  BoelsBaseSite,
  BoelsBaseSiteEntities,
  StorageKey,
} from '@boels/models';
import { Store, select } from '@ngrx/store';
import { Observable, filter } from 'rxjs';
import {
  loadBaseSites,
  setActiveBaseSite,
} from '../actions/site-context.actions';
import {
  getActiveBaseSiteEntity,
  getBaseSitesEntities,
  getCultureEntities,
} from '../selectors/site-context.selectors';

@Injectable({
  providedIn: 'root',
})
export class SiteContextFacade {
  private readonly store = inject(Store);
  private localStorageService = inject(LocalStorageService);

  loadBaseSites(): void {
    this.store.dispatch(loadBaseSites());
  }

  setBaseSite(baseSiteId: string) {
    this.localStorageService.setItem(StorageKey.BASESITE, baseSiteId);
    this.store.dispatch(setActiveBaseSite({ payload: baseSiteId }));
  }

  getBaseSites(): Observable<BoelsBaseSiteEntities> {
    return this.store.pipe(select(getBaseSitesEntities));
  }

  getActiveBaseSiteEntity(): Observable<BoelsBaseSite> {
    return this.store.pipe(select(getActiveBaseSiteEntity));
  }

  getAllIsocodes(): Observable<string[] | null> {
    return this.store.pipe(
      select(getCultureEntities),
      filter((cultures) => Boolean(cultures?.length)),
    );
  }
}
